import React, { useEffect } from "react";
import { loanService } from "../../../../api/services/loanService";
import { useAppSelector } from "../../../../infra/hooks";

const DTOCreateBoardModal = () => {
  return <></>;
};

export default DTOCreateBoardModal;
